import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { MediaProps, MediaType } from '../media-constant';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';

const PagerExamScheduleReadOnly = dynamicEditorComponent<MediaProps>(() =>
  import(/* webpackExports: "PagerExamScheduleReadOnly" */'./PagerExamSchedule').then((mod) => mod.PagerExamScheduleReadOnly)
);

const renderPagerExamSchedule = (opt: MediaProps) => (props: RenderElementProps) => {
  const { element } = props;
  if (element.type === MediaType.PAPER_EXAM) {
    return <PagerExamScheduleReadOnly url={element.url} id={element.id as string} {...opt} />;
  }
  return null;
};

export const PagerExamScheduleReadOnlyPlugin = (props?: MediaProps): SlatePlugin => {
  return {
    renderElement: renderPagerExamSchedule(props),
    voidTypes: [MediaType.PAPER_EXAM],
  };
};
